module.exports = __webpack_public_path__ + "static/media/29FUNOV15.81eb0ab7.jpg";